import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=69d94306&scoped=true&"
import script from "./PeriodicTable.vue?vue&type=script&lang=js&"
export * from "./PeriodicTable.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&id=69d94306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d94306",
  null
  
)

export default component.exports